<template>
  <div class="GroupForm">
    <el-container class="s-full">
      <el-main>
        <el-form label-width="80px" :model="data" :rules="rules" ref="form">
          <el-form-item :label="$t('lang.group_name')" prop="name">
            <el-input v-model="data.name" maxlength="25" />
          </el-form-item>
          <el-form-item :label="$t('lang.notes')">
            <el-input type="textarea" v-model="data.desc" maxlength="100" />
          </el-form-item>
          <el-form-item>
            <el-checkbox
              v-model="data.super_group_tag"
              @change="changeSuperGroup"
              >최고 권한 그룹</el-checkbox
            >
          </el-form-item>
        </el-form>
        <!-- <el-transfer
          class="transfer"
          v-model="value"          
          :data="authoryData"
          :titles="[$t('lang.no_authority'), $t('lang.have_authority')]"
          @change="transferData"
        ></el-transfer> -->
        <div class="flex-fixed flex">
          <div style="width:100px;" />
          <div style="width:601px;">
            <ATable
              ref="table"
              v-if="this.is_super_group ? false : true"
              max-height="250px"
              :data="authoryData"
              border
              hideTopPanel
              hideButtonInsert
              hide-pagination
            >
              <el-table-column prop="label" label="이름" width="250" />
              <el-table-column prop="level" label="권한" width="350">
                <template slot-scope="scope">
                  <ARadioGroup
                    :ref="scope.row.name + scope.row.id"
                    v-model="scope.row.level"
                    v-if="scope.row.parent_id === null ? false : true"
                    labelField="label"
                    valueField="value"
                    :items="level_items"
                  />
                </template>
              </el-table-column>
            </ATable>
          </div>
        </div>
      </el-main>
      <el-footer>
        <el-button
          type="primary"
          v-shortkey="['f4']"
          :disabled="!has_grant_write"
          @shortkey.native="clickReg"
          @click="clickReg"
          >{{ $t("button.ok") }}(F4)</el-button
        >
        <el-button
          type="danger"
          v-if="!is_new"
          :disabled="!has_grant_write"
          @click="clickDel"
          >{{ $t("button.delete") }}</el-button
        >
        <el-button class="close-button" @click="closeDialog"
          >{{ $t("button.close") }}(Esc)</el-button
        >
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "GroupForm",
  mixins: [form],
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "이름을 입력해 주세요.", trigger: "blur" },
        ],
      },
      authoryData: [],
      value: [],
      listData: [],
      updatedData: [],
      createDate: [],
      level_items: [
        { label: 0, value: "권한없음" },
        { label: 1, value: "읽기" },
        { label: 2, value: "읽기/쓰기" },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          name: "",
          desc: "",
          super_group_tag: "N",
          authorities: [],
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_user_authority", "userData"]),
    is_new: function() {
      // this.updatedData = this.data;
      // this.authorityData();
      return this.data.id < 1;
    },
    is_super_group: function() {
      return this.data.super_group_tag;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.listData = this.table_user_authority;
      this.updatedData = this.data;
      // this.authorityData();
      this.loadData();
    },
    loadData() {
      this.authoryData = [];

      if (this.data.super_group_tag === "Y") {
        this.data.super_group_tag = true;
      } else {
        this.data.super_group_tag = false;
      }

      this.listData.map((item) => {
        const authItem = this.data.authorities.find(
          (findItem) => findItem.user_authority_id === item.id
        );

        if (authItem) {
          item.user_group_id = authItem.id;
          if (authItem.level === null) item.level = 0;
          else item.level = authItem.level;
        } else {
          item.user_group_id = 0;
          item.level = 0;
        }
        item.label = this.getItemName(item.name);
      });

      this.authoryData = this.convertTreeData();
    },
    convertTreeData() {
      let parentNodeList = this.listData.filter((item) => {
        if (item.parent_id === null) {
          item.children = [];
          return item;
        }
      });
      for (var i = 0; i < this.listData.length; i++) {
        let userAuthData = this.listData[i];
        if (userAuthData.parent_id === null) continue;
        else {
          parentNodeList.find((item) => {
            if (item.id === userAuthData.parent_id) {
              item.children.push(userAuthData);
            }
          });
        }
      }
      return parentNodeList;
    },
    getItemName(name) {
      let itemName = "";
      switch (name) {
        case "stock_manage":
        case "stock_history":
        case "stock_inbound":
        case "code":
        case "cost":
        case "user":
        case "group":
        case "history":
          itemName = this.$t("lang.title_" + this.changeTitle(name));
          break;
        default:
          itemName = this.$t("title." + this.changeTitle(name));
          break;
      }
      return itemName;
    },
    changeSuperGroup(value) {
      this.data.super_group_tag = value;
    },
    /**Click the Modify button */
    clickReg() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doRegister();
      });
    },
    /**Click Delete button */
    clickDel() {
      this.util.confirm_delete(
        this,
        this.$t("lang.title_group") + "[" + this.data.name + "]",
        this.doDelete
      );
    },
    /**Get permission data*/
    authorityData() {
      (this.value = []), (this.authoryData = []);
      this.listData.map((item) => {
        const { id, name } = item;
        this.authoryData.push({
          key: id,
          label: this.$t("title." + this.changeTitle(name)),
          disabled: false,
        });
        const autid = this.data.authorities.find(
          (autiItem) => autiItem.user_authority_id === id
        );
        if (autid) this.value.push(autid.user_authority_id);
      });
    },
    /**Monitoring value changes*/
    transferData() {
      this.updatedData.authorities = [];
      this.value.map((item) => {
        var obj = {};
        obj.id = this.updatedData.id;
        obj.user_authority_id = item;
        obj.level = 1;
        this.updatedData.authorities.push(obj);
      });
    },
    changeTitle(key) {
      if (key === "contract") {
        return "contract_management";
      } else if (key === "contract_stat") {
        return "contract";
      } else if (key === "stock_manage") {
        return "stock";
      } else if (key === "stock_inbound") {
        return "inbound";
      } else if (key === "total_schedule") {
        return "schedule";
      } else {
        return key;
      }
    },
    /**Reorganization data */
    organizeData() {
      let param = Object.assign({}, this.data);
      return param;
    },
    configureAuthItem(data, item) {
      let authItem = data.authorities.find(
        (findItem) => findItem.user_authority_id === item.id
      );
      if (authItem) {
        authItem.level = item.level;
      } else {
        authItem = {};
        authItem.id = 0;
        if (item.parent_id === null) authItem.level = 1;
        else authItem.level = item.level;
        authItem.user_authority_id = item.id;
        data.authorities.push(authItem);
      }
    },
    /**Modify or add data */
    doRegister() {
      const data = this.organizeData();

      if (data.super_group_tag) {
        data.super_group_tag = "Y";
      } else {
        data.super_group_tag = "N";

        this.authoryData.forEach((item) => {
          // item.id is user_authority id
          item.children.forEach((childItem) => {
            this.configureAuthItem(data, childItem);
          });
          this.configureAuthItem(data, item);
        });
      }

      let api = this.is_new
        ? this.api.createUserGroup
        : this.api.updateUserGroup;
      api(data).then((res) => {
        if (this.is_new) {
          this.handleResultForSave(res, true);
        } else {
          this.handleResultForSave(res);
        }
      });

      // const data = this.organizeData();
      // if (this.is_new) {
      //   this.api.createUserGroup(data).then(res => {
      //     this.handleResultForSave(res, true);
      //   });
      // } else {
      //   this.api.updateUserGroup(this.updatedData).then(res => {
      //     this.handleResultForSave(res);
      //   });
      // }
    },
    /**Delete data */
    doDelete() {
      const data = this.organizeData();
      this.api.deleteUserGroup(data).then((res) => {
        this.handleResultForDelete(res);
      });
    },
    /**Preservation data in indexDB*/
    handleResultForSave(res, isCreate) {
      const message = isCreate ? "등록되었습니다" : "수정되었습니다.";
      this.handleResult(res, message);
    },
    handleResult(res, successMessage) {
      if (res.error === this.system.noError) {
        const options = this.getNotifyOptions(successMessage);
        this.$emit("completed", options);
        return;
      }
      this.util.notify_error(this, this.$t("lang.title_group"), res.message);
    },
    /**delete data in indexDB */
    handleResultForDelete(res) {
      this.handleResult(res, "삭제되었습니다.");
    },
    /** noti 옵션 반환 */
    getNotifyOptions(message) {
      return this.util.get_notify_options(
        "s",
        this.$t("lang.title_group"),
        message
      );
    },
  },
};
</script>
<style lang="scss">
.transfer {
  margin-left: 100px;
  height: 350px;
}
.el-transfer-panel {
  width: 350px;
  .el-transfer-panel__header {
    background-color: #cbf3f7;
  }
}
.el-transfer-panel:first-child .el-transfer-panel__header {
  background-color: #fdc9c9;
}
</style>
